export async function executeTx(contractTxPromise) {
    return contractTxPromise.then((tx) => tx.wait());
}
